import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { FloorMapService } from '../floor-map.service';
import * as XLSX from 'xlsx';
import { FloorMapAddModelComponent } from '../../floor-map-add-model/floor-map-add-model.component';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
  selector: 'app-import-popup',
  templateUrl: './import-popup.component.html',
  styleUrls: ['./import-popup.component.scss']
})
export class ImportPopupComponent {
  error: string;
  excelFile: any;
  data: any;
  matDialogRef: any;
  selectedFileName: string = '';

  constructor(public dialogRef: MatDialogRef<ImportPopupComponent>, private authService: AuthService,
    private floormapService: FloorMapService, private matDialog: MatDialog,
    private toast: ToastrService
  ) { }

  closePopup() {
    this.dialogRef.close();
  }
  /*-- To get import file --*/
  getExcelFile(evt: any) {
    const target: DataTransfer = <DataTransfer>(evt.target);

    if (!target?.files || target.files.length !== 1) {
      this.error = 'Please select a single CSV file.';
      return;
    }

    const file = target.files[0];
    this.selectedFileName = file.name;
    this.error = '';
    this.data = [];

    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      try {
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        const rawData: any[][] = XLSX.utils.sheet_to_json(ws, { header: 1 });

        if (!rawData || rawData.length <= 1) {
          this.error = 'The selected file contains no data.';
          // this.selectedFileName = '';
          return;
        }

        // Remove completely empty rows
        const filteredData = rawData.filter((row, index) => {
          if (index === 0) return true; // keep header
          return !this.isRowEmpty(row);
        });

        // If only header remains
        if (filteredData.length <= 1) {
          this.error = 'No valid data rows found in the CSV file. Please check the file and try again.';
          // this.selectedFileName = '';
          return;
        }

        this.data = filteredData;

      } catch (err) {
        this.error = 'Invalid or corrupted CSV file. Please upload a valid template.';
        this.selectedFileName = '';
        this.data = [];
      }
    };

    reader.readAsBinaryString(file);
  }

  importFloorsData() {
    if (!this.data || this.data.length <= 1) {
      this.error = 'No valid data available for upload.';
      return;
    }

    const keys = [
      'mapname', 'map_type', 'region', 'campus',
      'building', 'floor', 'address', 'center_lat',
      'center_lon', 'scale', 'area',
      'south_west_lat', 'south_west_lon',
      'north_east_lat', 'north_east_lon'
    ];

    const array = [];

    for (let j = 1; j < this.data.length; j++) {

      const row = this.data[j];

      if (this.isRowEmpty(row)) continue;

      let map: any = {};

      for (let i = 0; i < keys.length; i++) {
        map[keys[i]] = row[i] ? row[i].toString().trim() : '';
      }

      array.push(map);
    }

    if (array.length === 0) {
      this.error = 'No valid rows found to upload. Please verify the CSV content.';
      return;
    }

    console.log(array, 'Final Valid Data');

    this.matDialogRef = this.matDialog.open(FloorMapAddModelComponent, {
      data: { data: array, action: 'Import' },
      disableClose: true
    });

    this.dialogRef.close();

    this.matDialogRef.afterClosed().subscribe(() => {
      this.authService.refreshData();
    });
  }
  private isRowEmpty(row: any[]): boolean {
    if (!row || row.length === 0) return true;

    return row.every(cell => {
      return cell === null ||
            cell === undefined ||
            cell.toString().trim() === '';
    });
  }
  isEmpty(stringText) {
    if (stringText) {
      if (typeof stringText === 'string') {
        stringText = stringText.trim();
      }
    }
    if (stringText === '' || stringText === undefined || stringText === null || stringText === 'null') {
      return true;
    } else {
      return false;
    }
  }
}
